import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const classes = {
  showBuyBar: 'show-buy-bar',
  trigger: 'buy-bar-trigger'
};

const body = document.body;

export class BuyBarTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.addScrollHandlerSubscription();
    this.bindTriggeredListener();
  }

  addScrollHandlerSubscription() {
    dispatchEvent(window, events.ADD_SCROLL_SUBSCRIPTION, {
      selector: '.' + classes.trigger,
      eventName: events.SCROLL_HANDLER_TRIGGERED
    });
  }

  bindTriggeredListener() {
    this.element.addEventListener(events.SCROLL_HANDLER_TRIGGERED, (e) => {
      this.handleTriggered(e.detail.direction);
    });
  }

  handleTriggered(direction) {
    if (direction === 'down') {
      body.classList.add(classes.showBuyBar);
    } else {
      body.classList.remove(classes.showBuyBar);
    }
  }
}